import './SectionNavigation.css';

const SectionNavigation = ({ ariaLabel, children }) => (
  <nav className="sectionNavigation" aria-label={ariaLabel}>
    <div className="sectionNavigationInner">{children}</div>
  </nav>
);

export default SectionNavigation;
